import * as Yup from 'yup';

export const roleFormSchema = () => {
    const schema = Yup.object().shape({
        name: Yup.string().required('Name is required').trim(),
        description: Yup.string().required('Description is required').trim()
    });

    return schema;
}